import PhoneIphoneOutlined from '@mui/icons-material/PhoneIphoneOutlined';
import QrCode2Outlined from '@mui/icons-material/QrCode2Outlined';
import Box from '@mui/material/Box';

function PhoneQrIcon() {
  return (
    <Box
      sx={{
        position: 'relative',
        width: 160,
        height: 160,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      aria-hidden="true"
    >
      <PhoneIphoneOutlined
        color="primary"
        sx={{
          fontSize: 190,
          marginRight: -1,
          position: 'absolute',
        }}
      />

      <QrCode2Outlined
        color="primary"
        sx={{
          fontSize: 64,
          position: 'absolute',
        }}
      />
    </Box>
  );
}

export default PhoneQrIcon;
